import { useTranslation } from 'react-i18next';
import { PartnerPartnerDetails, SubPartnerAccount, withStyles } from 'vopay';
import { BodyText, Card, Title } from 'UI';
import usePartnerAccountInfoRows from '@/components/Partners/PartnerManagement/usePartnerAccountInfoRows';
import styles from './PartnerAccountInfo.module.scss';

const cn = withStyles(styles);

type PartnerAccountInfoProps = {
  partner: SubPartnerAccount;
  /** Undefined while the details load, null when the request failed. */
  details: PartnerPartnerDetails | null | undefined;
};

/** The drawer's Account Info card (spec 5.6.1): the rows `usePartnerAccountInfoRows` builds, titled. */
export default function PartnerAccountInfo({ partner, details }: PartnerAccountInfoProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'Partners.PartnerManagement.PartnerAccountInfo' });
  const rows = usePartnerAccountInfoRows(partner, details);

  return (
    <Card variant="section" className={cn('card')} data-testid="partnerAccountInfo">
      {/* Figma: H6/Title 15/Emphasized, as the account drawer's card titles. */}
      <Title level="6" className={cn('cardTitle')}>
        {t('title', { defaultValue: 'Account Info' })}
      </Title>

      <div className={cn('rows')}>
        {rows.map(({ label, value }) => (
          <div key={label} className={cn('row')}>
            {/* Figma: Body/16/Medium over Body/16/Regular in Text/Secondary75 */}
            <BodyText weight="md">{label}</BodyText>

            <BodyText className={cn('value')}>{value}</BodyText>
          </div>
        ))}
      </div>
    </Card>
  );
}
